<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"View Signed Contract" | translate}}</h5>
      <div class="edit-icons" mat-dialog-close="">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center" >
      <div class="table-container flex-grow-1 " *ngIf="!isSpinnerLoading">      
        <table class="" mat-table [dataSource]="dataSource" 
          class="mat-elevation-z8"  *ngIf="dataSource.data.length!=0">
          <ng-container matColumnDef="employee_info">
            <th mat-header-cell *matHeaderCellDef >
              {{"Employee Info"|translate}}</th>
            <td mat-cell *matCellDef="let element"> 
              <div class="d-flex flex-column flex-md-row align-items-md-center">
                <div class="profile-img me-2 d-none d-sm-block" [appBackgroundImg]="element.profile_picture"></div>
                {{ element.first_name }} {{ element.last_name }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="signed_time">
            <th mat-header-cell *matHeaderCellDef >
              {{"Signed Time"|translate}}</th>
            <td mat-cell *matCellDef="let element"> {{element.dep }}</td>
          </ng-container>
          <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef class="data-b">
              {{"Download"|translate}}</th>
            <td mat-cell *matCellDef="let element" class="data-b"> 
              <button mat-flat-button color="warn" class=" gradient-green-btn   ms-3" type="submit"
              (click)="onDownload(element)">
              <img src="assets/images/icons/download.png" class="img-fluid me-1"> Download</button>
            </td>
          </ng-container>
           
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="mat-table__message" *ngIf="dataSource.data.length==0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>
      <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
  <app-loading-spinner></app-loading-spinner>